export default function WhyChooseUs() {
  const benefits = [
    {
      icon: 'ri-file-forbid-line',
      title: 'No Income Verification',
      description: 'Qualify based on property cash flow, not personal income. Perfect for self-employed investors.',
    },
    {
      icon: 'ri-speed-up-line',
      title: 'Fast Closing',
      description: 'Close in as little as 21 days with our streamlined approval process and dedicated support team.',
    },
    {
      icon: 'ri-money-dollar-circle-line',
      title: 'Competitive Rates',
      description: 'Starting at 6.5% with flexible terms. Lock in your rate and start building wealth today.',
    },
    {
      icon: 'ri-building-2-line',
      title: 'Multiple Properties',
      description: 'Finance up to 10 properties simultaneously. Scale your portfolio without income limits.',
    },
    {
      icon: 'ri-shield-check-line',
      title: 'Trusted Lender',
      description: 'Over $2.5B funded and 10,000+ satisfied investors. A+ BBB rating and 4.9/5 customer reviews.',
    },
    {
      icon: 'ri-customer-service-2-line',
      title: 'Expert Support',
      description: 'Dedicated loan officers guide you through every step. Get answers fast and close with confidence.',
    },
  ];

  return (
    <section className="py-20 bg-gradient-to-br from-blue-900 via-blue-800 to-blue-950 text-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        {/* Section Header */}
        <div className="text-center mb-16">
          <h2 className="text-4xl md:text-5xl font-bold mb-4">
            Why Choose Our DSCR Loans?
          </h2>
          <p className="text-xl text-blue-200 max-w-3xl mx-auto">
            We make investment property financing simple, fast, and flexible. 
            Here's what sets us apart from traditional lenders.
          </p>
        </div>

        {/* Benefits Grid */}
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
          {benefits.map((benefit, index) => (
            <div
              key={index}
              className="group bg-white/5 backdrop-blur-sm rounded-2xl p-8 border border-white/10 hover:bg-white/10 hover:border-yellow-500/50 transition-all duration-300 hover:-translate-y-2 hover:shadow-2xl hover:shadow-yellow-500/20"
            >
              {/* Icon */}
              <div className="w-16 h-16 flex items-center justify-center bg-gradient-to-br from-yellow-500 to-yellow-600 rounded-xl mb-6 group-hover:scale-110 transition-transform shadow-lg group-hover:shadow-yellow-500/50">
                <i className={`${benefit.icon} text-3xl text-slate-900`}></i>
              </div>

              {/* Content */}
              <h3 className="text-xl font-bold mb-3 group-hover:text-yellow-400 transition-colors">
                {benefit.title}
              </h3>
              <p className="text-blue-200 leading-relaxed">
                {benefit.description}
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
